const compareLabels = (a, b) => String(a || '').localeCompare(String(b || ''), undefined, {
  sensitivity: 'base',
  numeric: true,
});

export const buildCampaignTree = (campaigns = [], search = '') => {
  const query = String(search || '').trim().toLowerCase();
  const owners = new Map();

  (Array.isArray(campaigns) ? campaigns : []).forEach((campaign) => {
    const ownerId = String(campaign.ownerUserId || 'unknown');
    const ownerName = campaign.ownerOrganizationName || 'Unknown account';
    const siteId = String(campaign.advertiserSiteId || 'unknown');
    const siteName = campaign.advertiserSiteName || 'Unknown site';
    const searchable = [ownerName, siteName, campaign.title, campaign.campaignId]
      .join(' ')
      .toLowerCase();
    if (query && !searchable.includes(query)) return;

    if (!owners.has(ownerId)) {
      owners.set(ownerId, { ownerId, ownerName, sites: new Map() });
    }
    const owner = owners.get(ownerId);
    if (!owner.sites.has(siteId)) {
      owner.sites.set(siteId, { siteId, siteName, campaigns: [] });
    }
    owner.sites.get(siteId).campaigns.push(campaign);
  });

  return [...owners.values()]
    .map((owner) => ({
      ownerId: owner.ownerId,
      ownerName: owner.ownerName,
      sites: [...owner.sites.values()]
        .map((site) => ({
          ...site,
          campaigns: site.campaigns.sort((a, b) => compareLabels(a.title, b.title)),
        }))
        .sort((a, b) => compareLabels(a.siteName, b.siteName)),
    }))
    .sort((a, b) => compareLabels(a.ownerName, b.ownerName));
};
